module.exports = {
    HOST:
        process.env.NODE_ENV !== 'production'
            ? 'http://localhost:4028/api'      // Development server URL
            : 'https://server.aichyoa.com/api' // Production server URL
};